import { getPortfolioId } from "../../promises";

export const usePortfolioAndAccountSelection = async (
  accounts_param: string | null,
  local_metadata: any,
  org_metadata: any,
  all_accounts_enabled: boolean
) => {
  const ALL_ACCOUNTS = "all-accounts";
  const ACCOUNTS_PARAM = accounts_param;
  const ZERO_INDEX_PORTFOLIO =
    org_metadata?.portfolios[0]?.portfolio_id || null;
  const ZERO_INDEX_ACCOUNT =
    org_metadata?.portfolios[0]?.accounts[0]?.account_id || null;
  const LOCAL_PORTFOLIO =
    local_metadata?.selected_portfolio?.portfolio_id || null;
  const ZERO_INDEX_ACCOUNT_BY_LOCAL_PORTFOLIO =
    local_metadata?.selected_portfolio?.accounts[0]?.account_id || null;
  const LOCAL_ACCOUNT = local_metadata?.selected_account?.account_id || null;
  const PORTFOLIO_BY_ACCOUNT = await getPortfolioId(
    "account",
    ACCOUNTS_PARAM,
    org_metadata.portfolios
  );
  const PORTFOLIO_BY_LOCAL_ACCOUNT = await getPortfolioId(
    "account",
    LOCAL_ACCOUNT,
    org_metadata.portfolios
  );

  const {
    validated_accounts_param,
    validated_all_accounts,
    validated_local_account,
    validated_local_portfolio,
  } = {
    validated_accounts_param: !!accounts_param,
    validated_all_accounts: accounts_param === ALL_ACCOUNTS,
    validated_local_portfolio: !!local_metadata?.selected_portfolio,
    validated_local_account:
      !!local_metadata?.selected_account &&
      local_metadata.selected_account.account_id !== ALL_ACCOUNTS,
  };

  if (
    !validated_accounts_param &&
    !validated_all_accounts &&
    !validated_local_portfolio &&
    !validated_local_account
  ) {
    return {
      portfolio_id_res: ZERO_INDEX_PORTFOLIO,
      account_id_res: ZERO_INDEX_ACCOUNT,
    };
  } else if (
    validated_accounts_param &&
    !validated_all_accounts &&
    !validated_local_portfolio &&
    !validated_local_account
  ) {
    return {
      portfolio_id_res: PORTFOLIO_BY_ACCOUNT.data?.portfolio_id || null,
      account_id_res: ACCOUNTS_PARAM,
    };
  } else if (
    !validated_accounts_param &&
    !validated_all_accounts &&
    validated_local_portfolio &&
    !validated_local_account
  ) {
    return {
      portfolio_id_res: LOCAL_PORTFOLIO,
      account_id_res: ZERO_INDEX_ACCOUNT_BY_LOCAL_PORTFOLIO,
    };
  } else if (
    !validated_accounts_param &&
    !validated_all_accounts &&
    !validated_local_portfolio &&
    validated_local_account
  ) {
    return {
      portfolio_id_res: PORTFOLIO_BY_LOCAL_ACCOUNT.data?.portfolio_id || null,
      account_id_res: LOCAL_ACCOUNT,
    };
  } else if (
    validated_accounts_param &&
    validated_all_accounts &&
    !validated_local_portfolio &&
    !validated_local_account
  ) {
    return {
      portfolio_id_res: ZERO_INDEX_PORTFOLIO,
      account_id_res: all_accounts_enabled ? ALL_ACCOUNTS : ZERO_INDEX_ACCOUNT,
    };
  } else if (
    validated_accounts_param &&
    !validated_all_accounts &&
    validated_local_portfolio &&
    !validated_local_account
  ) {
    return {
      portfolio_id_res: PORTFOLIO_BY_ACCOUNT.data?.portfolio_id || null,
      account_id_res: ACCOUNTS_PARAM,
    };
  } else if (
    validated_accounts_param &&
    !validated_all_accounts &&
    !validated_local_portfolio &&
    validated_local_account
  ) {
    return {
      portfolio_id_res: PORTFOLIO_BY_ACCOUNT.data?.portfolio_id || null,
      account_id_res: ACCOUNTS_PARAM,
    };
  } else if (
    !validated_accounts_param &&
    !validated_all_accounts &&
    validated_local_portfolio &&
    validated_local_account
  ) {
    return {
      portfolio_id_res: LOCAL_PORTFOLIO,
      account_id_res: LOCAL_ACCOUNT,
    };
  } else if (
    validated_accounts_param &&
    !validated_all_accounts &&
    validated_local_portfolio &&
    validated_local_account
  ) {
    return {
      portfolio_id_res: PORTFOLIO_BY_ACCOUNT.data?.portfolio_id || null,
      account_id_res: ACCOUNTS_PARAM,
    };
  } else if (
    validated_accounts_param &&
    validated_all_accounts &&
    validated_local_portfolio &&
    !validated_local_account
  ) {
    return {
      portfolio_id_res: LOCAL_PORTFOLIO,
      account_id_res: all_accounts_enabled
        ? ALL_ACCOUNTS
        : ZERO_INDEX_ACCOUNT_BY_LOCAL_PORTFOLIO,
    };
  } else if (
    validated_accounts_param &&
    validated_all_accounts &&
    validated_local_portfolio &&
    validated_local_account
  ) {
    return {
      portfolio_id_res: LOCAL_PORTFOLIO,
      account_id_res: all_accounts_enabled
        ? ALL_ACCOUNTS
        : ZERO_INDEX_ACCOUNT_BY_LOCAL_PORTFOLIO,
    };
  } else {
    return {
      portfolio_id_res: ZERO_INDEX_PORTFOLIO,
      account_id_res: ZERO_INDEX_ACCOUNT,
    };
  }
};
